export default {
  screens: [
    {
      type: 'intro',
      title: '君主が選ぶ物',
      content:
        '驚くことに、教皇ピウス7世のティアラは、ショーメとジョゼフィーヌの出会いをもたらすものとなりました。',
      idYt: 'q7zuNJ10apM',
      videoCover: 'world/sovereign/video.jpg',
      desktop: {
        cover: 'world/sovereign/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sovereign/mobile-cover-1.jpg',
        contentStyle: { width: '70%' },
        coverStyle: {
          width: '110%',
          top: '90%',
          left: '15%',
          position: 'absolute'
        }
      },
      isBottom: true
    },
    {
      type: 'columnVideo',
      content:
        'ナポレオンによる最も重要な外交上の贈り物である教皇ピウス7世に贈呈されたティアラ。これは、1804年12月2日にノートルダム大聖堂で行われた聖別式への教皇の参列に感謝して、ナポレオンの依頼により作られました。 ',
      idYt: 'O-1TKgKxDdg',
      videoCover: 'world/sovereign/video-2.jpg',
      cover: 'world/sovereign/cover-2.jpg',
      isBottom: true
    },
    {
      type: 'video',
      middleImg: 'world/sovereign/tiare.jpg',
      videoBlock: {
        cover: 'world/sovereign/video-3.jpg',
        idYt: '5ExHUFrxFms'
      },
      content:
        'この美術展のために、教皇庁はショーメにティアラの修復に加えて、頂上の見事なエメラルドの上に飾る新しい十字架の制作を依頼しました。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/sovereign.js